@if (notifications.length) {
  <div class="notification-container errors animated slideInUp">
    <div i18n class="notification-header">
    <span class="material-icons notification-image">error</span>
    Der folgende Anwendungsfehler ist aufgetreten:
    <button class="notification-copy-btn" title="Anwendungsfehler in Zwischenablage kopieren." (click)="copyError()">
      <i class="material-icons">content_copy</i>
    </button>
    <button class="notification-close-btn" title="Schließen" (click)="closeGlobalNotifications()">
      <i class="material-icons">close</i>
    </button>
  </div>
    @for (notify of notifications; track notify.message; let i = $index) {
      <div class="notification-text">
        @if (notify) {
          <div>{{notify.message}}</div>
        }
        @if (notify?.details) {
          <div>
            <a class="notification-details-link" (click)="isShowDetails[i] = !isShowDetails[i]">Details</a>
            @if (isShowDetails[i]) {
              <div class="notification-details" [innerHtml]="notify.details | safeHtml"></div>
            }
          </div>
        }
      </div>
    }
  </div>
}
